const training = {
  // HeroSection
  'training.hero.homeLink': 'Home',
  'training.hero.aboutLink': 'About the Academy',
  'training.hero.currentPage': 'Practical Training',
  'training.hero.title': 'Practical Training',
  'training.hero.titleEn': 'PRACTICAL TRAINING',
  'training.hero.lead': 'Practical work and role-play set in real-world scenarios are at the heart of learning at the Academy. Students commit knowledge to muscle memory quickly — building the readiness to perform in genuine professional settings.',
  'training.hero.imgAlt': 'Students during a practical training session',

  // BasicTraining
  'training.basic.label': 'BASIC TRAINING',
  'training.basic.title': 'Foundation Training',
  'training.basic.titleEn': 'Basic Training',
  'training.basic.description': 'We begin with theory to lay the groundwork, then move directly into hands-on practice. On the day a student learns about table setting, for example, they immediately set up a formal dinner — so that learning stays in the body, not just the head. \n\nBy minimising the gap between lecture and practice, knowledge becomes physical competence.',
  'training.basic.imgAlt': 'Foundation training in progress',
  'training.basic.0.title': 'Lecture and Practice Directly Linked',
  'training.basic.0.description': 'Practical exercises follow immediately after each lecture, reinforcing retention and allowing students to resolve questions on the spot.',
  'training.basic.1.title': 'Strictly Small-Group',
  'training.basic.1.description': 'A maximum of six students per class ensures that every individual receives the instructor\'s full attention and is guided at their own pace.',
  'training.basic.2.title': 'Repetition as a Core Principle',
  'training.basic.2.description': 'Fundamental techniques are repeated as many times as needed. Instructors persevere until correct posture, gait, and hand movement become second nature.',

  // BasicTraining hardcoded texts
  'training.basic.imgCaption': 'Students practising a formal dinner setting',
  'training.basic.sectionTitle': 'What does the practical training involve?',
  'training.basic.sectionTitleEn': 'Theory Meets Practice',

  // RolePlaying
  'training.roleplay.label': 'ROLE-PLAYING',
  'training.roleplay.title': 'Role-Playing Sessions',
  'training.roleplay.titleEn': 'Role-Playing Practice',
  'training.roleplay.description': 'In real-world situations, the unexpected happens. That is why students practise repeatedly across a wide range of scenarios — from everyday domestic service to formal dinner management and emergency response. \n\nWorking in authentic-feeling environments builds the adaptability to handle anything.',
  'training.roleplay.scenario.label': 'Level',
  'training.roleplay.0.title': 'Daily Service',
  'training.roleplay.0.titleEn': 'Daily Service',
  'training.roleplay.0.level': 'Foundation',
  'training.roleplay.0.description': 'Scenarios based on everyday household management and guest reception. Training begins with tea service, basic table setting, and foundational technique drills.',
  'training.roleplay.1.title': 'Formal Dinner',
  'training.roleplay.1.titleEn': 'Formal Dinner',
  'training.roleplay.1.level': 'Intermediate',
  'training.roleplay.1.description': 'Running a full-course dinner for multiple guests. Students practise the complete experience — from table coordination through wine service to attending to each guest individually.',
  'training.roleplay.2.title': 'Crisis Management',
  'training.roleplay.2.titleEn': 'Crisis Management',
  'training.roleplay.2.level': 'Advanced',
  'training.roleplay.2.description': 'High-level scenarios involving unexpected incidents and emergency situations. Students train in calm, decisive judgement and the composure to reassure those around them. Covered in the Master course.',
  'training.roleplay.feature.0.label': 'Authentic setting',
  'training.roleplay.feature.0.text': 'Scenarios are faithfully recreated in a studio modelled on private residences and luxury hotels.',
  'training.roleplay.feature.1.label': 'Progressive challenge',
  'training.roleplay.feature.1.text': 'Students advance steadily from foundational techniques at the introductory level to complex crisis response at the advanced level.',
  'training.roleplay.feature.2.label': 'Immediate feedback',
  'training.roleplay.feature.2.text': 'The instructor provides a detailed critique directly after each session, making areas for improvement clear on the spot.',

  // RolePlaying additional
  'training.roleplay.sectionTitleEn': 'Real Scenarios, Real Growth',
  'training.roleplay.level.0': 'Foundation',
  'training.roleplay.level.1': 'Intermediate',
  'training.roleplay.level.2': 'Advanced',

  // FeedbackSystem additional
  'training.feedback.sectionTitleEn': 'Observe, Review, Improve',
  'training.feedback.imgAlt': 'A student receiving individual feedback from an instructor',
  'training.feedback.imgCaption': 'Receiving individual instructor feedback — a core part of every session',

  // FeedbackSystem
  'training.feedback.label': 'FEEDBACK SYSTEM',
  'training.feedback.title': 'The Feedback Process',
  'training.feedback.titleEn': 'Feedback System',
  'training.feedback.description': 'Every practical session is followed by a structured debrief. Instructors observe each student\'s technique, judgement, and communication in detail, then provide specific, individual feedback covering both strengths and areas for improvement. This cycle of debrief — improvement — retry is what drives genuine growth.',
  'training.feedback.0.step': '01',
  'training.feedback.0.title': 'Observation',
  'training.feedback.0.titleEn': 'Observation',
  'training.feedback.0.description': 'The instructor records the student\'s technique, judgement, and manner of speech throughout the role-play in detail.',
  'training.feedback.1.step': '02',
  'training.feedback.1.title': 'Individual Debrief',
  'training.feedback.1.titleEn': 'Review',
  'training.feedback.1.description': 'Immediately after the session, each student receives verbal feedback. Strengths are acknowledged first, followed by specific guidance on areas to improve.',
  'training.feedback.2.step': '03',
  'training.feedback.2.title': 'Improvement in Practice',
  'training.feedback.2.titleEn': 'Improvement',
  'training.feedback.2.description': 'Students take the feedback on board and attempt the same scenario again. The satisfaction of overcoming a previous challenge reinforces their progress.',
  'training.feedback.3.step': '04',
  'training.feedback.3.title': 'Progress Record',
  'training.feedback.3.titleEn': 'Progress Record',
  'training.feedback.3.description': 'Assessments are accumulated so that each student can look back and reflect on their own growth over time.',

  // SafetyEquipment
  'training.safety.label': 'AUTHENTIC EQUIPMENT',
  'training.safety.title': 'Real Equipment, Real Standards',
  'training.safety.titleEn': 'Safety & Authenticity',
  'training.safety.description': 'All practical instruction at the Academy uses genuine equipment and tools — not replicas. Handling the real thing teaches students the feel, weight, and correct technique through the body. \n\nStudents also wear white gloves from the very first day, establishing the foundations of professional deportment from the outset.',
  'training.safety.0.title': 'Authentic Equipment',
  'training.safety.0.description': 'Training uses genuine items found in real private residences — crystal glassware, silverware, fine porcelain, and more.',
  'training.safety.1.title': 'White Gloves from Day One',
  'training.safety.1.description': 'Students wear professional white gloves from the first session. \n\nEvery movement of the hands is trained to convey elegance and precision from the very beginning. \n\nThe white glove derives from the nineteenth-century British practice of footmen in upper-class houses waiting at table in white cotton gloves, and it carried the practical purpose of handling silver and porcelain without leaving fingerprints. \n\nButlers themselves did not invariably wear gloves — the custom differed by period and occasion — but at the Academy they are worn throughout practical sessions so that precision and cleanliness are learned in the body.',
  'training.safety.2.title': 'Safety as a Priority',
  'training.safety.2.description': 'All practical sessions are conducted under the supervision of experienced instructors. We minimise the risk of injury or damage so that students can learn with confidence.',

  // SafetyEquipment additional
  'training.safety.sectionTitleEn': 'Real Tools, Real Skills',
  'training.safety.imgAlt': 'Close-up of white-gloved hands arranging silverware',
  'training.safety.imgCaption': 'Arranging cutlery in white gloves — practical sessions using authentic equipment',

  // FAQSection
  'training.faq.label': 'FAQ',
  'training.faq.title': 'Frequently Asked Questions',
  'training.faq.titleEn': 'Frequently Asked Questions',
  'training.faq.footer': 'For further enquiries, please use our contact form.',
  'training.faq.0.question': 'How much of the programme is hands-on?',
  'training.faq.0.answer': 'The curriculum is designed so that everything covered in a lecture is immediately practised. Table setting, service training, and real-world role-play are at the centre of the learning experience.',
  'training.faq.1.question': 'What kinds of scenarios are used?',
  'training.faq.1.answer': 'A wide range of scenarios is covered — from everyday household and domestic service through to formal dinner management and emergency response.',
  'training.faq.2.question': 'Can I try the practical training before enrolling?',
  'training.faq.2.answer': 'Yes. Our one-day taster session gives you the chance to experience butler deportment and tea service in person.',

  // CTASection
  'training.cta.label': 'NEXT STEP',
  'training.cta.title': 'Explore Further',
  'training.cta.body': 'Browse the study materials that underpin practical training, or see the full map of skills you will acquire. Or simply come and feel the atmosphere at a taster session.',
  'training.cta.note': '* Online consultations are also available.',
  'training.cta.materials': 'View Study Materials',
  'training.cta.skills': 'View Skills Map',
  'training.cta.seminar': 'Try the Training at a Taster Session',

  // RelatedPages
  'training.related.label': 'LEARN MORE',
  'training.related.title': 'Related Pages',
  'training.related.titleEn': 'Explore Further',
  'training.related.viewLink': 'Learn more',
  'training.related.0.title': 'Study Materials',
  'training.related.0.desc': 'All 15 specialist textbooks supervised by the Association',
  'training.related.1.title': 'Skills Map',
  'training.related.1.desc': 'Five skill domains developed through study',
  'training.related.2.title': 'Curriculum Overview',
  'training.related.2.desc': 'The overall structure and approach to learning',
  'training.related.3.title': 'One-Day Taster Session',
  'training.related.3.desc': 'Experience butler training in a single day',

  // Last updated
  'training.lastUpdated': 'Last updated: 8 July 2026',
};

export default training;
